module.exports = __webpack_public_path__ + "img/thumbnail_Mandrill_f_normal.e43827d6.png";